import React from "react";
import { AnnsModal, Col, FormDatePicker } from "../../../components/Component";
import { Form } from "reactstrap";
import { useState } from "react";
import { useEffect } from "react";

const ExtendModal = ({ visible, item, onSaved, onClosed }) => {
  const [extendReason, setExtendReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [charCount, setCharCount] = useState(0);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setCharCount(extendReason?.length);

    if (selectedDate) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  }, [extendReason, selectedDate]);

  const close = () => {
    onClosed();
    setLoading(false);
    setExtendReason("");
    setSelectedDate(null);
  };

  useEffect(() => {
    if (onSaved) {
      setExtendReason("");
      setSelectedDate(null);
    }
  }, [onSaved]);

  const onFormSubmit = () => {
    if (isDisable) return;

    onSaved(selectedDate, extendReason);
  };

  return (
    <>
      <AnnsModal
        size={"md"}
        isOpen={visible}
        toggle={() => close()}
        title="Extend Report"
        onClick={() => onFormSubmit()}
        disabled={isDisable}
        loading={loading}
      >
        <Form
          className="row gy-4 form-validation"
          onSubmit={(e) => {
            e.preventDefault();
            onFormSubmit();
          }}
        >
          <Col md="12">
            <div className="form-group">
              <label className="form-label">
                Extend Date<span className="text-danger fs-6">*</span>
              </label>
              <div className="form-control-wrap">
                <FormDatePicker
                  selected={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                  }}
                  minDate={new Date()}
                />
              </div>
            </div>
          </Col>
          <Col md="12">
            <div className="form-group">
              <label className="form-label">Extend Reason</label>
              <div className="form-control-wrap">
                <textarea
                  className="form-control"
                  placeholder="Write your extend reason"
                  maxLength={200}
                  value={extendReason}
                  onChange={(e) => {
                    setExtendReason(e.target.value);
                  }}
                />
                <span className="d-flex justify-content-end pt-1">{charCount}/200</span>
              </div>
            </div>
          </Col>
        </Form>
      </AnnsModal>
    </>
  );
};

export default ExtendModal;
